import { lazy } from "react";

const pages = {
  // Login
  Login: lazy(() => import("./Login")),
  ForgotPassword: lazy(() => import("./ForgotPassword")),
  ResetPassword: lazy(() => import("./ResetPassword")),
  // Company
  Company: lazy(() => import("./Company")),
  CreateCompany: lazy(() => import("./Company/new")),
  EditCompany: lazy(() => import("./Company/edit")),
  // Member
  Member: lazy(() => import("./Member")),
  CreateMember: lazy(() => import("./Member/new")),
  EditMember: lazy(() => import("./Member/edit")),
  Wallet: lazy(() => import("./Member/wallet")),
  MassUpload: lazy(() => import("./Member/MassUploadData.js")),
  // Transaction
  Transaction: lazy(() => import("./Transaction")),
  // Report
  MonthlyReport: lazy(() => import("./Report/Monthly")),
  DailyReport: lazy(() => import("./Report/Daily")),

  //   Acceptance Points
  AcceptancePoints: lazy(() => import("./AcceptancePoints")),
  CreateAcceptancePoint: lazy(() => import("./AcceptancePoints/new")),
  EditAcceptancePoint: lazy(() => import("./AcceptancePoints/edit")),
  //   Campaign
  Campaign: lazy(() => import("./Campaign")),
  CreateCampaign: lazy(() => import("./Campaign/new")),
  EditCampaign: lazy(() => import("./Campaign/edit")),
  //   Operators
  Operators: lazy(() => import("./Operators")),
  CreateOperator: lazy(() => import("./Operators/new")),
  EditOperator: lazy(() => import("./Operators/edit")),
  //   Billing
  PaymentProfile: lazy(() => import("./Billing/PaymentProfile")),
  NewCard: lazy(() => import("./Billing/PaymentProfile/new")),
  Invoices: lazy(() => import("./Billing/Invoices")),
  // User
  User: lazy(() => import("./User")),
  CreateUser: lazy(() => import("./User/new")),
  // POS
  POS: lazy(() => import("./POS")),
  NewPOS: lazy(() => import("./POS/new.js")),
  PosAllocation: lazy(() => import("./POS/allocation.js")),
  PosOnline: lazy(() => import("./POS/online.js")),
  PosStatus: lazy(() => import("./POS/status.js")),
};

export default pages;
